<template>
  <div class="main-content">
    <div>
      <a href="https://www.figma.com/file/MC48vUUguBidnS5y7rZFnb/%5BBAROGO%5D-Design-System_Vuetify?node-id=2495-207750&t=66N2Sdb3tRl4kNPW-11">
        피그마 링크
      </a>
    </div>

    <br />
    <br />

    <h2>SIZE</h2>
    <v-btn
      v-btn-style:config.primary.size-xxs
    >
      size-xxs 28px
    </v-btn>
    <v-btn
      v-btn-style:config.primary.size-xs
    >
      size-xs 32px
    </v-btn>
    <v-btn
      v-btn-style:config.primary.size-s
    >
      size-s 36px
    </v-btn>
    <v-btn
      v-btn-style:config.primary.size-m
    >
      size-m 40px
    </v-btn>
    <v-btn
      v-btn-style:config.primary.size-l
    >
      size-l 44px (default!)
    </v-btn>
    <v-btn
      v-btn-style:config.primary.size-xl
    >
      size-xl 52px
    </v-btn>

    <br />
    <br />

    <h2>WIDTH</h2>
    <v-btn
      v-btn-style:config.primary.width-xxs
    >
      xxs 100px;
    </v-btn>
    <br />
    <br />
    <v-btn
      v-btn-style:config.primary.width-xs
    >
      xs 150px
    </v-btn>

    <br />
    <br />

    <v-btn
      v-btn-style:config.primary.width-s
    >
      s 200px
    </v-btn>

    <br />
    <br />

    <v-btn
      v-btn-style:config.primary.width-m
    >
      m 260px
    </v-btn>

    <br />
    <br />

    <v-btn
      v-btn-style:config.primary.width-fill
    >
      fill 100%
    </v-btn>

    <br />
    <br />

    <h2>COLOR & STYLE</h2>

    <v-btn
      v-btn-style:config.primary
    >
      primary
    </v-btn>

    <v-btn
      v-btn-style:config.danger
    >
      danger
    </v-btn>

    <v-btn
      v-btn-style:config.info.size-m
    >
      info
    </v-btn>

    <v-btn
      v-btn-style:config.orange.size-m
    >
      orange
    </v-btn>

    <br />
    <br />

    <h2>OUTLINED</h2>

    <v-btn
      v-btn-style:config.primary.outlined
    >
      primary outlined
    </v-btn>
    <v-btn
      v-btn-style:config.danger.outlined
    >
      danger outlined
    </v-btn>
    <v-btn
      v-btn-style:config.info.outlined
    >
      info outlined
    </v-btn>
    <v-btn
      v-btn-style:config.orange.outlined
    >
      orange outlined
    </v-btn>

    <br />
    <br />
    <h2>DISABLED</h2>
    <v-btn
      v-btn-style:config.info
      disabled
    >
      disabled
    </v-btn>

    <span>&nbsp;&nbsp;</span>

    <v-btn
      class="brg-btn info"
      disabled
    >
      <v-icon>
        mdi-map-marker-outline
      </v-icon>
      버튼
    </v-btn>

    <v-btn
      class="brg-btn primary outlined"
      disabled
    >
      primary disabled
    </v-btn>

    <v-btn
      class="brg-btn orange outlined"
      disabled
    >
      orange disabled
    </v-btn>

    <br />
    <br />

    <h3>사용예시</h3>
    <v-btn
      v-btn-style:config.primary
    >
      <v-icon>
        mdi-magnify
      </v-icon>
      버튼 안에 아이콘이 있으면 그것은 16px이 됩니다 😄
    </v-btn>

    <br />
    <br />
    <v-btn
      v-btn-style:config.size-xs.info.outlined
    >
      <v-icon
        size="16"
      >
        mdi-magnify
      </v-icon>
      라이더 설정
    </v-btn>

    <br />
    <br />

    <v-btn
      v-btn-style:config.info.width-s.size-xl.outlined
    >
      <v-icon>
        mdi-magnify
      </v-icon>
      목록보기
    </v-btn>

    <br />
    <br />

    <v-card
      width="688"
    >
      <v-card-text>
        블라블라
        <v-btn
          v-btn-style:config.primary.outlined.size-l.width-fill
        >
          <v-icon>
            mdi-plus
          </v-icon>
          라이더 수수료 그룹 추가
        </v-btn>
      </v-card-text>
    </v-card>
  </div>
</template>
<script setup lang="ts">
</script>
